import type {
  FeatureFlagKey,
  FeatureFlagService,
} from "../services/feature-flags";

export interface ModuleContentView {
  readonly body: string;
  readonly heading: string;
  readonly kind: "content";
  readonly mount?: (container: HTMLElement) => void;
}

export interface ModuleErrorView {
  readonly body: string;
  readonly heading: string;
  readonly kind: "error-card";
}

export interface ModuleUnavailableView {
  readonly body: string;
  readonly heading: string;
  readonly kind: "unavailable";
}

export type ModuleView =
  | ModuleContentView
  | ModuleErrorView
  | ModuleUnavailableView;

export interface TrainingModule {
  readonly featureFlag: FeatureFlagKey;
  readonly id: string;
  readonly title: string;
  render(): ModuleContentView;
}

export function resolveModuleView(
  module: TrainingModule,
  flags: FeatureFlagService,
): ModuleView {
  if (!flags.isEnabled(module.featureFlag)) {
    return {
      kind: "unavailable",
      heading: module.title,
      body: "This module is not enabled in this build.",
    };
  }

  try {
    return module.render();
  } catch (error: unknown) {
    return {
      kind: "error-card",
      heading: `${module.title} could not start`,
      body: error instanceof Error ? error.message : "Unknown module failure.",
    };
  }
}
